import { z } from 'zod'

// Faz 0: varsayılanlı (boot'u engellemez). Faz 1'de gerçek API'ye bağlanınca sıkılaştırılır.
const schema = z.object({
  VITE_QG_BACKEND_URL: z.string().default('http://localhost:8001/api/v1'),
  // Ollama (yerel) sağlayıcısı üretim formunda seçilebilir mi. 'false' → dropdown'da
  // Ollama disabled görünür (seçilemez). Backend QGEN_OLLAMA_ENABLED ile aynı tutulmalı.
  VITE_QG_OLLAMA_ENABLED: z
    .string()
    .default('true')
    .transform((value) => value !== 'false'),
})

const parsed = schema.safeParse(import.meta.env)

if (!parsed.success) {
  console.error('[env] geçersiz ortam', parsed.error.flatten().fieldErrors)
  throw new Error('Geçersiz QG frontend ortamı. Konsola bakın.')
}

export const env = parsed.data

export const config = {
  apiUrl: env.VITE_QG_BACKEND_URL,
  ollamaEnabled: env.VITE_QG_OLLAMA_ENABLED,
}
